import React from 'react'
import check from '../../../assets/images/check-mark.png'
import close from '../../../assets/images/cancel.png'
import add_friend from '../../../assets/images/add-group.png'

const CardEvents = ({ backColor, Accepted, Declined, Invited, init }) => {
    return (
        <div className='card-event' style={{ backgroundColor: backColor }} >
            <div className='card-event-top' >
                <span className='tooltip-event' >Event</span>
                {
                    Accepted && (
                        <div className='div-typee' >
                            <span style={{color: "#64748B",fontSize: "14px"}} >Accepted</span>
                            <img style={{width: "13px" , height:"13px",marginLeft: "4px"}} src={check} />
                        </div>
                    )
                }
                {
                    init && (
                        <div className='card-event-top-icons' >
                            {/*<FontAwesomeIcon style={{color: "#FF5D5B"}} className='icon-event' icon={faClose} />
                            <FontAwesomeIcon style={{color: "#1C5E91"}} className='icon-event' icon={faCheck} />*/}
                            <i className='fa fa-close icon-event' style={{color: "#FF5D5B"}} ></i>
                            <i className='fa fa-check icon-event' style={{color: "#FF5D5B"}}></i>
                        </div>
                    )
                }
                {
                    Declined && (
                        <div className='div-typee' >
                            <span  style={{color: "#64748B",fontSize: "14px"}}>Declined</span>
                            <img style={{width: "13px" , height:"13px",marginLeft: "4px"}} src={close} />
                        </div>
                    )
                }
                {
                    Invited &&(
                        <div className='div-typee' >
                            <span  style={{color: "#64748B",fontSize: "14px"}}>Invited</span>
                            <img style={{width: "13px" , height:"13px",marginLeft: "4px"}} src={add_friend} />
                        </div>
                    )
                }

            </div>
            <div className='card-event-bottom' >
                <div className='card-event-bottom-left' >
                    <span style={{ marginBottom: "7px" }} >Meeting with Raju</span>
                    <span>12 Jan 2023 [9 am - 11 am]</span>
                </div>
                <div className='card-event-bottom-images' >
                    <img src="https://www.georgetown.edu/wp-content/uploads/2022/02/Jkramerheadshot-scaled-e1645036825432-1050x1050-c-default.jpg" />
                    <img src='https://t3.ftcdn.net/jpg/02/43/12/34/360_F_243123463_zTooub557xEWABDLk0jJklDyLSGl2jrr.jpg' />
                    <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGVyc29ufGVufDB8fDB8fHww" />
                </div>
            </div>
        </div>
    )
}

export default CardEvents